import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customCurrency',
})
export class CustomCurrencyPipe implements PipeTransform {
  transform(
    value: number,
    currency: string,
    compact: boolean = false,
    showDashes: boolean = false
  ): string {
    if (value == 0 && showDashes) {
      return '--';
    }

    if (compact) {
      let formatter = Intl.NumberFormat('en', {
        notation: 'compact',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatter.format(value) + ' ' + currency;
    }

    // Check if the value is negative
    const isNegative = value < 0;

    // Remove the negative sign
    const absValue = Math.abs(value);

    // Format the absolute value with commas and fixed decimals
    const formattedValue = absValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

    // Add parentheses for negative values
    const result = isNegative ? '(' + formattedValue + ')' : formattedValue;

    return result + ' ' + currency;
  }
}
